<template>
  <div>
    <v-autocomplete
      :value="pump"
      :items="filterPumps"
      :label="label === null ? $i18n.t('Fuel Pump Select') : label"
      @change="changedTo"
      ref="select"
      :loading="loading"
      :clearable="clearable"
      :rules="rules"
      @click:clear="clear"
      :search-input.sync="filter"
      autocomplete="nope"
      :no-filter="true"
    >
      <template v-slot:selection="data">
        <div ripple class="height32">
          <h5 class="text-title">{{ data.item.name }}</h5>
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title>
              <div>{{ data.item.name }}</div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import common from "@/store/common/module/common";
import { commonMixin } from "@/mixins/common";
import corpService from "@/store/common/module/CorpService";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "FuelPumpSelect",
  props: {
    value: {
      default: false,
    },
    clearable: {
      default: false,
    },
    label: {
      default: null,
    },
  },
  mixins: [Themeable, commonMixin],
})
export default class FuelPumpSelect extends (Vue, Themeable) {
  pump = null;
  loading = true;
  filter = "";

  clear() {
    this.filter = "";
    this.pump = null;
    this.$emit("input", null);
  }

  get filterPumps() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    const pumps = corpService.pumps;
    if (filterby == "") return pumps;
    const fc = pumps.filter(function(c) {
      return c.name.toLowerCase().indexOf(filterby) >= 0;
    });
    return fc;
  }

  changedTo(newVal) {
    this.filter = "";
    this.$emit("input", newVal);
    // if (newVal) {
    //   this.pump = newVal;
    //   this.$emit("input", newVal._id);
    // } else {
    //   this.$emit("input", null);
    // }
    // if (!newVal) this.$emit("input", null);
  }

  setDefault() {
    if (this.value) {
      for (let i = 0; i < this.pumps.length; i++) {
        if (this.pumps[i]._id === this.value) {
          this.pump = this.pumps[i];
          this.pump_id = this.pumps[i]._id;
          break;
        }
      }
    }
  }

  async mounted() {
    await corpService.populatePumps();
    this.pumps = corpService.pumps;
    this.setDefault();
    this.loading = false;
  }

  @Watch("value")
  async onValueChange() {
    if (this.value == "" || this.value == null) {
      this.pumps = null;
    }
    await corpService.populatePumps();
    this.pumps = corpService.pumps;
    this.setDefault();
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 60px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.flag-img {
  float: left;
  margin-right: 10px;
  height: 20px;
  width: 24px;
  margin: 5px 10px 2px 0;
}
</style>
